import { render, staticRenderFns } from "./PortfolioHeader.vue?vue&type=template&id=3bc00688&scoped=true"
import script from "./PortfolioHeader.vue?vue&type=script&lang=js"
export * from "./PortfolioHeader.vue?vue&type=script&lang=js"
import style0 from "./PortfolioHeader.vue?vue&type=style&index=0&id=3bc00688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc00688",
  null
  
)

export default component.exports